import HTTPServices from "../HTTPServices/httpService";

const orderServices = {
  //(1)
  searchNameOrPhone: async function (customerGUID) {
    // console.log("'orderServices' service called: searchword: " + customerGUID);
    // return await HTTPServices.post("customer/searchNameOrPhone", customerGUID);
    // // let result =await HTTPServices.post("customer/searchNameOrPhone", searchWord);
    // // debugger;
    // // console.log('retrun result --->'+ result);
    // // return result;
  },
  //(2)
  save: function (customerObj) {
    // console.log("'customerServices' service called: save : " + customerObj);
    // return HTTPServices.post("customer/save", customerObj);
  },
  //(2)
  saveOrder: async function (orderObj) {
    console.log("'orderServices' service called: saveOrder : " + orderObj);
    let result = await HTTPServices.post("order/save", orderObj);
    // debugger;
    console.log("retrun result --->" + result);
    return result;
  },

  getOrderDetailVMByTrackingNo: async function (trackingNo) {
    console.log(
      "'getOrderDetailVMByTrackingNo' service called: trackingNo: " + trackingNo
    );
    let result = await HTTPServices.post(
      "order/GetCustomerAndOrderAndOrderDetailByTrackingNo",
      trackingNo
    );
    // debugger;
    console.log("retrun result --->" + JSON.stringify(result));
    return result;
  },

  //(3)
  getOrderVMByCustomerID: async function (customerID) {
    console.log(
      "'getOrderVMByCustomerID' service called: customerID: " + customerID
    );
    let result = await HTTPServices.post(
      "order/GetOrderVMByCustomerID",
      customerID
    );
    // debugger;
    console.log("retrun result --->" + JSON.stringify(result));
    return result;
  },
  //(4)
  getOrderInfoByOrderGUID: async function (orderGUID) {
    // alert("'getOrderInfoByOrderGUID' service called: orderGUID: " + orderGUID);
    console.log(
      "'getOrderInfoByOrderGUID' service called: orderGUID: " + orderGUID
    );
    let result = await HTTPServices.post(
      "order/GetOrderInfoByOrderGUID",
      orderGUID
    );
    // debugger;
    console.log("retrun result --->" + result);
    return result;
  },
  //(5)
  getOrderItemByOrderGUID: async function (orderGUID) {
    // alert("'getOrderItemByOrderGUID' service called: orderGUID: " + orderGUID);
    console.log(
      "'getOrderItemByOrderGUID' service called: orderGUID: " + orderGUID
    );
    let result = await HTTPServices.post(
      "order/GetOrderItemByOrderGUID",
      orderGUID
    );
    // debugger;
    console.log("retrun result --->" + JSON.stringify(result));
    return result;
  },

  GetOrderItemWithCommentByOrderGUID: async function (orderGUID) {
    // alert("'getOrderItemByOrderGUID' service called: orderGUID: " + orderGUID);
    console.log(
      "'GetOrderItemWithCommentByOrderGUID' service called: orderGUID: " +
        orderGUID
    );
    let result = await HTTPServices.post(
      "order/GetOrderItemWithCommentByOrderGUID",
      orderGUID
    );
    // debugger;
    console.log(
      "retrun result 'GetOrderItemWithCommentByOrderGUID' --->" +
        JSON.stringify(result)
    );
    return result;
  },

  //(6)
  deleteByOrderGUID: async function (orderGUID) {
    console.log("'deleteByOrderGUID' service called : " + orderGUID);
    let result = await HTTPServices.post("order/deleteByOrderGUID", orderGUID);

    return result;
  },

  //(7)
  sendSMSOfOrderConfirm: async function (orderGUID) {
    console.log("'orderServices' service called: saveOrder : " + orderGUID);
    let result = await HTTPServices.post(
      "sms/sendSMSOfOrderConfirm",
      orderGUID
    );
    // debugger;
    console.log("SMS retrun result --->" + JSON.stringify(result));
    return result;
  },
};

export default orderServices;

// {
//   email: "email",
//   password: "password",
// }

//   // POST request using fetch inside useEffect React hook
//   const requestOptions = {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ title: 'React Hooks POST Request Example' })
// };
// fetch('https://reqres.in/api/posts', requestOptions)
//     .then(response => response.json())
//     .then(data => setPostId(data.id));
